/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import '../../assets/quill.css';
import '../../assets/trix.css';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'eventtia-ui-components/lib/Modal';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
// import LinearProgress from '@material-ui/core/LinearProgress';
import clsx from 'clsx';
import useRoutes from '../../hooks/useRoutes';
import Button from '../../components/Button';
import Message from '../../components/Message';
import useDidUpdate from '../../hooks/useDidUpdate';
import callApi from '../../actions/callApi';
import { setActiveWorkshop } from '../../actions/app';
import handleWorkshopLinkClick from '../../helpers/interceptWorkshopLinks';
import forceLinksInNewTab from '../../helpers/forceLinksInNewTab';
import { baseMoment, getEventTimeFormat, showInEventTimezone, toAPStyleTime } from '../../helpers/dates';
import { getModuleByType, getCurrentAttendee } from '../../helpers/getters';
import { getPriceByAttendeeId, getWorkshopName, getWorkshopDescription } from '../../helpers/workshops';
import attendanceModeHelper from '../../helpers/attendanceModeHelper';
import Biography from '../Biography';
import { getUpdateRegistrationUrl } from '../../helpers/endpoints';
import CustomPropTypes from '../../helpers/CustomPropTypes';
import AttachmentFile from '../../components/AttachmentFile';
// import agendaIconGold from '../../assets/ActivityOutline.png';
import DownloadActivity from '../../components/DownloadActivity';
import {
  ATTENDANCE_MODE,
  WORKSHOP_CATEGORIES,
} from '../../helpers/constants';
import useStringTransforms from '../../hooks/useStringTransforms';
import intlLocales from '../../helpers/intlLocales';
import usePolling from '../../hooks/usePolling';

const useStyles = makeStyles((theme) => ({
  root: {
    '& ::-webkit-scrollbar': {
      width: 10,
      height: 10,
    },
    /* Handle */
    '& ::-webkit-scrollbar-track': {
      WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: 10,
    },
    '& ::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
      borderRadius: theme.spacing(1),
    },
    /* Handle on hover */
    '& ::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.primary.dark,
    },
  },
  subtitle: {
    fontWeight: 'bold',
    margin: theme.spacing(5, 0, 2, 0),
    color: theme.palette.darkGrey.main,
  },
  description: {
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    '& img': {
      height: 306,
      width: 'auto',
    },
  },
  invitation: {
    margin: theme.spacing(2, 0, 1),
    '& i': {
      color: theme.palette.primary.light,
    },
  },
  message: {
    position: 'sticky',
    bottom: theme.spacing(4),
  },
  advice: {
    margin: theme.spacing(2, 0, 1),
    '& button': {
      display: 'none',
    },
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'center',
  },
  modalButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
    boxShadow: 'none',
    fontFamily: 'Avenir Next',
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '100%',
    letterSpacing: '0.04em',
    textAlign: 'center',
  },
  modalBtnCancel: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: '#D4D3D4',
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    margin: theme.spacing(0, -1),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  button: {
    maxWidth: 'calc(50% - 16px)',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      maxWidth: '100%',
    },
    centeredButton: {
      alignItems: 'center',
    },
    width: '234px',
    fontFamily: 'Brilliant Cut Pro',
    fontWeight: 500,
    fontStyle: 'medium',
    fontSize: 12,
    lineHeight: '100%',
    letterSpacing: '0.04em',
    textAlign: 'center',
    textTransform: 'uppercase',
    boxShadow: 'none',
  },
  logoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  logoCartier: {
    width: 167,
    height: 132,
    objectFit: 'contain',
    marginBottom: 30,
  },
  avatarsSlider: {
    overflowY: 'hidden',
    width: '100%',
  },
  sliderContent: {
    whiteSpace: 'nowrap',
  },
  avatar: {
    margin: theme.spacing(2, 0),
    display: 'inline-flex',
    height: 90,
    width: 90,
    boxShadow: theme.customShadows.small,
  },
  avatarInSlider: {
    marginLeft: theme.spacing(-5),
    '&:first-of-type': {
      marginLeft: theme.spacing(2.5),
    },
    '&:last-of-type': {
      marginRight: theme.spacing(2.5),
    },
  },
  logoAvatar: {
    '& img': {
      objectFit: 'contain',
    },
  },
  imageAvatar: {
    borderRadius: '50%',
    height: 90,
    width: 90,
    objectFit: 'cover',
    fontSize: 70,
    '&:hover': {
      height: 100,
      width: 100,
      backgroundColor: theme.palette.lightGrey.main,
      borderStyle: 'solid',
      borderColor: theme.palette.primary.light,
      objectFit: 'cover',
      zIndex: 1,
    },
  },
  noAvatar: {
    fontSize: '2em',
  },
  timespan: {
    color: theme.palette.darkGrey.dark,
    fontSize: 20,
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'Fancy Cut Pro',
    fontStyle: 'Italic',
    fontWeight: 400,
    lineHeight: '100%',
    letterSpacing: 0,
    textAlign: 'center',
    marginBottom: theme.spacing(),
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  speakerLine: {
    marginTop: theme.spacing(1.5),
    lineHeight: '100%',
    fontFamily: 'Fancy Cut Pro',
    fontSize: 18,
    fontStyle: 'italic',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginBottom: theme.spacing(2.25),
    fontWeight: '400',
  },
  startTime: {
    whiteSpace: 'nowrap',
  },
  chooseActivity: {
    fontFamily: 'Avenir Next',
    letterSpacing: 1,
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
  },
  name: {
    textTransform: 'uppercase',
    color: theme.palette.darkGrey.dark,
    fontSize: 12,
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(0.75),
    textAlign: 'center',
    fontFamily: 'Brilliant Cut Pro',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: 0,
    '& span': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      // fontSize: 24,
      marginTop: 0,
    },
  },
  icon: {
    fontSize: 14,
    marginRight: theme.spacing(0.5),
  },
  timeIcon: {
    width: 11,
    height: 11,
    marginRight: 5,
  },
  locationIcon: {
    width: 13,
    height: 13,
  },
  location: {
    fontFamily: 'Brilliant Cut Pro',
    color: theme.palette.darkGrey.dark,
    fontSize: 12,
    lineHeight: '100%',
    fontWeight: '700',
    letterSpacing: '0.04em',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    textTransform: 'capitalize',
    [theme.breakpoints.down('sm')]: {
      // fontSize: 14,
    },
  },
  timeRange: {
    marginTop: theme.spacing(4),
    color: theme.palette.darkGrey.main,
    fontFamily: 'Avenir Next',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '100%',
    letterSpacing: '0.04em',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  divider: {
    marginTop: theme.spacing(4.75),
    marginBottom: theme.spacing(3.125),
    border: '2px solid rgba(123, 118, 118, 0.08)',
    backgroundColor: 'rgba(123, 118, 118, 0.08)',
    '& .MuiDivider-root': {
      height: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
  },
  job: {
    fontSize: theme.typography.subtitle2.fontSize,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  filesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  modalPaper: {
    padding: theme.spacing(2),
    borderRadius: 2,
  },
  dialog: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.darkGrey.main,
    padding: theme.spacing(2),
    cursor: 'auto',
    boxShadow: theme.customShadows.default,
  },
  modalContent: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
  modalText: {
    fontWeight: 'bold',
    fontFamily: 'Avenir Next',
  },
  modalHelperText: {
    marginTop: theme.spacing(1),
    fontSize: theme.typography.caption.fontSize,
  },
  attendanceModeMessage: {
    boxShadow: '0px 3px 6px #00000029',
  },
  image: {
    height: 'auto',
    width: '100%',
  },
  price: {
  },
  newMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(5.5),
    // paddingBottom: theme.spacing(10),
    // alignItems: 'center',
    // gap: theme.spacing(3),
    // [theme.breakpoints.down('sm')]: {
    //   marginTop: theme.spacing(3),
    //   gap: 0,
    //   paddingBottom: theme.spacing(8),
    // },
  },
  workshopDetails: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 0,
  },
  detailsName: {
    textAlign: 'start',
    fontSize: 15,
    fontWeight: 700,
  },
  detailsStartTime: {
    fontSize: 15,
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  detailsDescription: {
    fontFamily: 'Fancy Cut Pro',
    color: theme.palette.darkGrey.main,
    fontSize: 16,
    lineHeight: '100%',
    fontWeight: '400',
    letterSpacing: '0.04em',
    marginTop: theme.spacing(2),
    '& figure': {
      display: 'none',
    },
    '& a': {
      '& figcaption': {
        display: 'none',
      },
    },
  },
  secondRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
  thirdRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
  remainingSeatsText: {
    textTransform: 'uppercase',
    color: theme.palette.darkGrey.dark,
    fontSize: 15,
    fontWeight: 700,
    marginBottom: theme.spacing(0.75),
    fontFamily: 'Brilliant Cut Pro',
    lineHeight: '100%',
    textAlign: 'center',
    leadingTrim: 'NONE',
    letterSpacing: 0,
  },
  optionalWorkshopHelperText: {
    color: theme.palette.secondary.main,
    fontSize: 17,
    fontFamily: 'Fancy Cut Pro',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '100%',
    letterSpacing: 0,
    textAlign: 'center',
    marginBottom: theme.spacing(0.75),
    leadingTrim: 'none',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 400,
      letterSpacing: 0,
    },
  },
  registeredAttendeeLabels: {
    color: theme.palette.secondary.main,
    fontSize: 18,
    fontFamily: 'Fancy Cut Pro',
    fontWeight: 500,
    lineHeight: '100%',
    letterSpacing: 0,
  },
  smallContainer: {
    marginTop: theme.spacing(2),
  },
  addToCalendarBtn: {
    textTransform: 'uppercase',
    width: 320,
    backgroundColor: theme.palette.common.white,
    fontSize: 12,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    fontFamily: 'Brilliant Cut Pro',
    fontWeight: '500',
    lineHeight: '100%',
    letterSpacing: '0.04em',
  },
  unregisterBtn: {
    fontFamily: 'Brilliant Cut Pro',
    width: 320,
    textTransform: 'uppercase',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    fontSize: 12,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    lineHeight: '100%',
    letterSpacing: '0.04em',
    '&:hover': {
      backgroundColor: '#D4D3D4',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 250,
    },
  },
  registeredTime: {
    fontFamily: 'Avenir Next',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '100%',
    letterSpacing: '0.04em',
    textAlign: 'center',
    textTransform: 'capitalize',
    color: theme.palette.darkGrey.main,
  },
  notInterested: {
    fontFamily: 'Avenir Next',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '100%',
    letterSpacing: '0.04em',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      textAlign: 'center',
      maxWidth: 250,
    },
  },
  reminder: {
    fontFamily: 'Avenir Next',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '100%',
    letterSpacing: '0.04em',
    textAlign: 'center',
    marginTop: -theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginTop: theme.spacing(1.5),
      maxWidth: 300,
      lineHeight: '140%',
    },
  },
  reminderDate: {
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: '0%',
    marginLeft: theme.spacing(0.5),
  },
  descriptionContainer: {
    marginTop: theme.spacing(3.375),
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    width: '234px',
  },
}));

const { VIRTUAL, PHYSICAL } = ATTENDANCE_MODE;

// const BorderLinearProgress = withStyles((theme) => ({
//   root: {
//     width: '100%',
//     height: 16,
//     borderRadius: 15,
//     backgroundColor: theme.palette.primary.light,
//   },
//   bar: {
//     borderRadius: 15,
//     backgroundColor: theme.palette.secondary.light,
//   },
// }))(LinearProgress);

const Workshop = ({
  attendeeUnregisterError,
  attendeeRegisterSuccess, attendeeRegisterError,
  workshop,
  speakers,
  callApi: dispatchCallApi,
  setActiveWorkshop: dispatchSetActiveWorkshop,
  eventFiles,
  speakerId,
  events,
  appSettings,
  attendeeWorkshops,
  workshopDefinitions,
  entities,
  currentAttendanceMode,
}) => {
  const classes = useStyles();

  const { toTitleCase } = useStringTransforms();
  const { eventUri, locale } = useParams();
  const { goTo } = useRoutes();

  const [settings] = Object.values(appSettings);
  const {
    customParams: { itemsToShow, allowRegistration },
  } = getModuleByType(settings.modules, 'Workshops');
  const highlightRegistered = itemsToShow === 'attendee_type_and_highlight_registered';
  const offsetToUtc = !showInEventTimezone(settings);

  const {
    id: wId, streamingType, location,
    startDate, endDate, fileCategoryId, showOnRegister, price,
    sponsorId, availability, usedSeats, attendanceMode: workshopAttendanceMode,
    workshopCategories, streamingEmbedCode,
  } = workshop;

  const name = getWorkshopName(workshop, workshopDefinitions, locale);
  const description = getWorkshopDescription(workshop, workshopDefinitions, locale);

  const currentAttendee = getCurrentAttendee(entities);
  const attendeeUuid = currentAttendee?.uuid;

  const timeFormat = getEventTimeFormat(events);
  const [{ currency }] = Object.values(events);
  const { t } = useTranslation(['schedule', 'stage', 'global']);

  const workshopEnded = baseMoment().isAfter(endDate);
  const workshopIsInTheFuture = baseMoment().isBefore(startDate);
  // const live = baseMoment().isBetween(startDate, endDate, undefined, '[)'); // TODO tick?

  const currentPrice = getPriceByAttendeeId(currentAttendee.attendeeType.id, price);
  const freeWorkshop = currentPrice === 0;
  const formattedPrice = `${currency} ${new Intl.NumberFormat(intlLocales[locale]).format(currentPrice)}`;

  const attendeeIsRegistered = Object.values(attendeeWorkshops || {}).find(
    ({ attendee: { id: aId }, workshop: { id: workshopId } }) => (
      aId === currentAttendee.id && workshopId === wId
    )
  );
  const attendeeIsRegisteredAndPaid = (
    attendeeIsRegistered && (freeWorkshop || currentAttendee.paid)
  );

  const activeSpeaker = speakers[speakerId];
  const [event] = Object.values(events);
  // const eventMap = event?.staticMap;
  const { canRegisterMidWorkshop, timezone: eventTimezone } = event || {};

  const currentAttendeeTypeId = currentAttendee.attendeeType.id;
  const { attendeeTypes } = entities;
  const attendeeTypeAttendanceMode = attendeeTypes[currentAttendeeTypeId].attendanceMode;

  // const urlFixed = (url) => { // TODO use the one defined in helper and rename
  //   if (!/^https?:\/\//i.test(url)) return `http://${url}`;
  //   return url;
  // };

  const workshopSpeakers = workshop.speakers?.map(({ id: wSpeakerId }) => {
    const {
      bio, id, fullName, picture, company, position,
    } = speakers[wSpeakerId];
    return {
      bio,
      id,
      fullName,
      company,
      position,
      picture,
    };
  });

  const [modalType, setModalType] = useState(false);
  const closeModal = () => setModalType();

  const register = () => dispatchCallApi('registerAttendee', { eventUri, workshopId: wId });
  const unregister = () => {
    dispatchCallApi('unregisterAttendee', { eventUri, workshopId: wId });
    closeModal();
  };

  const goToRegistrationUpdate = () => {
    dispatchCallApi('registrationToken', { eventUri }).then(({
      response: {
        register_token: registerToken,
      },
    }) => {
      const attendeeRegistrationUpdateLink = getUpdateRegistrationUrl(
        eventUri, attendeeUuid, registerToken
      );
      window.open(attendeeRegistrationUpdateLink, '_blank').focus();
    });
    closeModal();
  };
  const registerToPaid = async () => {
    if (!attendeeIsRegistered) await register();
    dispatchCallApi('refetchCurrentAttendee', { eventUri, id: currentAttendee.id, offsetToUtc });

    goToRegistrationUpdate();
  };

  const modalConfig = {
    unregister: {
      text: t('stage:activity.unregisterConfirm', { activity: name }),
      onAccept: unregister,
      buttonText: t('stage:actions.unregister'),
    },
    registerToPaid: {
      text: t('stage:activity.registerToPaidConfirm'),
      helperText: (
        <Typography className={classes.modalHelperText}>
          <b>{t('stage:activity.itCosts', { price: formattedPrice })}</b> {t('stage:activity.registerToPaidHelperText')}
        </Typography>
      ),
      onAccept: registerToPaid,
      buttonText: t('stage:actions.register'),
    },
  };

  const [message, setMessage] = useState({
    title: undefined,
    message: undefined,
    type: undefined,
  });

  const [showAdvice, setShowAdvice] = useState(true);

  useEffect(() => {
    if (wId && fileCategoryId) dispatchCallApi('workshopsFiles', { eventUri, fileCategoryId, id: wId });
  }, [eventUri, wId, fileCategoryId, dispatchCallApi]);
  const workshopFiles = Object.values(eventFiles).filter(
    (file) => file.entityType === 'Workshop' && file.entityId.toString() === wId
  );

  useDidUpdate(() => {
    const errorMsg = attendeeRegisterError || attendeeUnregisterError;
    if (attendeeRegisterError) setMessage({
      message: 'You are already registered for another activity. If you want to change your selection, please unregister from the one you previously selected, then register for the new one.',
      type: 'error',
    });
    if (attendeeUnregisterError) setMessage({ title: t('registrationMessages.errorUnregisterOnWorkshopTitle'), message: errorMsg, type: 'warning' });
  }, [attendeeUnregisterError, attendeeRegisterError, setMessage, t]);

  useDidUpdate(() => {
    if (attendeeRegisterSuccess) setMessage({ title: t('registrationMessages.registeredOnWorkshopTitle'), message: t('registrationMessages.registeredOnWorkshopDescription'), type: 'success' });
  }, [attendeeRegisterSuccess, setMessage, t]);

  let peopleElement;
  if (workshopSpeakers.length > 1) peopleElement = workshopSpeakers.map(
    ({ fullName }) => fullName
  ).join(', ');
  else if (workshopSpeakers.length === 1) {
    const { fullName, position } = speakers[workshopSpeakers[0].id];
    peopleElement = `${toTitleCase(fullName)}, ${toTitleCase(position)}`;
  }

  // const { trackOnce } = useTraces(wId, ENTITY_TYPES.WORKSHOP, false);
  const goToReplay = () => goTo('replay.show', { workshopId: wId });
  const joinStream = () => goTo('stage.show', { workshopId: wId });
  //   if (sponsorId && ongoingWorkshop) {
  //     const push = trackOnce(0);
  //     if (push) push.receive('ok').receive('error', ({ reason }) => {
  //       // eslint-disable-next-line no-console
  //       console.error('failed to join channel', reason);
  //     });
  //   }
  //   const shouldOpenTab = !['youtube', 'other', 'daily_co', 'eventtia_studio']
  //     .includes(streamingType) && zoomType !== 'embedded';
  //   if (!(sponsorId && shouldOpenTab)) goTo(
  //   'stage.show', { workshopId: wId }
  // ); // TODO why sponsorId
  //   if (shouldOpenTab) window.open(urlFixed(streamingUrl), '_blank', 'noopener noreferrer');

  // const canJoinWorkshopStream = attendanceModeHelper.canJoinWorkshopStream(
  //   workshopAttendanceMode, currentAttendanceMode, attendeeTypeAttendanceMode
  // );

  const canRegisterByAttendanceMode = attendanceModeHelper.canRegisterByAttendanceMode(
    workshopAttendanceMode, attendeeTypeAttendanceMode
  );

  const wrongAttendanceMode = attendanceModeHelper.showWrongAttendanceModeMessage(
    workshopAttendanceMode, currentAttendanceMode, attendeeTypeAttendanceMode
  );

  // const showJoinButton = !fetchingCurrentAttendee && (
  //   sponsorId
  //     ? (!!streamingUrl && (attendeeIsRegisteredAndPaid || !showOnRegister))
  //     // TODO verify these
  //     : (!!streamingType && canJoinWorkshopStream && (
  //       !highlightRegistered || attendeeIsRegisteredAndPaid || !showOnRegister
  //     ))
  // );

  const showJoinButton = streamingType === 'other' && !!streamingEmbedCode?.[0]?.embedCode;

  const showFreeRegisterButton = freeWorkshop
  && canRegisterByAttendanceMode
  && (workshopIsInTheFuture || (canRegisterMidWorkshop && !workshopEnded))
  && (
    sponsorId ? (
      showOnRegister && !attendeeIsRegistered
    ) : (
      highlightRegistered && !attendeeIsRegistered && allowRegistration && showOnRegister
    )
  ); // TODO and these

  const showRegisterToPaidWorkshopButton = (
    workshopIsInTheFuture
    || (canRegisterMidWorkshop && !workshopEnded)
  )
  && allowRegistration
  && !freeWorkshop
  && canRegisterByAttendanceMode
  && (!attendeeIsRegistered || !currentAttendee?.paid);

  const [physicalOnlyMessage, setPhysicalOnlyMessage] = useState({});

  useEffect(() => {
    if (workshopAttendanceMode === PHYSICAL && wrongAttendanceMode) setPhysicalOnlyMessage(
      { title: t('schedule:title.physicallyOnlyActivity'), message: t('schedule:info.physicallyOnlyActivity'), type: 'warning' }
    );
  }, [currentAttendanceMode, t, workshopAttendanceMode, wrongAttendanceMode]);

  const [virtualOnlyMessage, setVirtualOnlyMessage] = useState({});

  useEffect(() => {
    if (workshopAttendanceMode === VIRTUAL && wrongAttendanceMode) setVirtualOnlyMessage(
      { title: t('schedule:title.virtuallyOnlyActivity'), message: t('schedule:info.virtuallyOnlyActivity'), type: 'warning' }
    );
  }, [currentAttendanceMode, t, workshopAttendanceMode, wrongAttendanceMode]);

  usePolling({
    endpoint: 'refetchCurrentAttendee',
    params: { eventUri, id: currentAttendee.id, offsetToUtc },
    duration: 15000,
    active: (attendeeIsRegistered && !currentAttendee?.paid),
  });

  const purchaseButton = attendeeIsRegistered ? {
    label: t('stage:activity.payPendingCharges'),
    onClick: goToRegistrationUpdate,
  } : {
    label: t('stage:actions.purchase'),
    onClick: () => setModalType('registerToPaid'),
  };

  const isOptional = workshopCategories.some(
    ({ id }) => id === WORKSHOP_CATEGORIES.optional
  );
  const isMandatory = workshopCategories.some(
    ({ id }) => id === WORKSHOP_CATEGORIES.mandatory
  );
  const isUmbrella = workshopCategories.some(
    ({ id }) => id === WORKSHOP_CATEGORIES.umbrella
  );
  const isActivite = workshopCategories.some(
    ({ id }) => id === WORKSHOP_CATEGORIES.activites
  );

  const replayAvailable = false;

  // const progress = (workshop.usedSeats / workshop.availability) * 100;

  // Para tener en cuenta segun lo que digan del funcionamiento de la descripción
  // const wrapper = document.createElement('div');
  // wrapper.innerHTML = description;
  // const imgHtml = wrapper.querySelector('img');
  // if (imgHtml) imgHtml.remove();
  // const textHtml = wrapper.innerHTML;

  return (
    <div className={classes.root}>
      {activeSpeaker
        ? (
          <Biography
            speaker={activeSpeaker}
          />
        )
        : (
          <>
            <Message
              onClose={() => setPhysicalOnlyMessage(undefined)}
              type={physicalOnlyMessage?.type}
              title={physicalOnlyMessage?.title}
              message={physicalOnlyMessage?.message || undefined}
              className={classes.attendanceModeMessage}
            />
            <Message
              onClose={() => setVirtualOnlyMessage(undefined)}
              type={virtualOnlyMessage?.type}
              title={virtualOnlyMessage?.title}
              message={virtualOnlyMessage?.message || undefined}
              className={classes.attendanceModeMessage}
            />

            {/* {(attendeeIsRegistered && !!isOptional) && (
              <Typography className={classes.registeredAttendeeLabels}>
                Your registration was successful!
              </Typography>
            )} */}

            <div
              className={classes.logoContainer}
            >
              <img
                src="https://cdn.eventtia.com/event_files/231019/original/asset-2-1-2x.png?1772737631"
                alt="cartier womens logo"
                className={classes.logoCartier}
              />
            </div>
            <Typography className={classes.timespan}>
              <span>{baseMoment.utc(startDate).tz(eventTimezone).format('dddd, MMMM D')}</span>
            </Typography>
            {peopleElement && (
              <Typography className={classes.speakerLine}>
                {peopleElement}
              </Typography>
            )}
            <Typography className={classes.name} component="div">
              {name},
              <span style={{ textTransform: 'none' }}> {toAPStyleTime(baseMoment.utc(startDate).tz(eventTimezone).format(timeFormat))}</span>
            </Typography>

            {location && (
              <Typography className={classes.location} component="div">
                {location}
              </Typography>
            )}

            <div className={classes.divider}>
              <Divider />
            </div>

            {!!currentPrice && (
              <>
                <Typography className={classes.subtitle}>{t('title.price')}</Typography>
                <Typography variant="body2" className={classes.price}>
                  {formattedPrice}
                </Typography>
              </>
            )}

            {/* NEW DESIGN - FIGMA CARTIER */}
            {(attendeeIsRegistered) && (
              <>
                <div className={classes.workshopDetails}>
                  <Typography className={clsx(classes.name, classes.detailsName)}>
                    {name}
                  </Typography>
                  <Typography className={classes.detailsStartTime}>
                    {toAPStyleTime(baseMoment.utc(startDate).tz(eventTimezone).format(timeFormat))}
                  </Typography>

                  {!!description && (
                    <Typography component="div" className={classes.detailsDescription}>
                      <div
                        role="presentation"
                        onClick={handleWorkshopLinkClick(dispatchSetActiveWorkshop)}
                        className={clsx('trix-content', classes.description)}
                        dangerouslySetInnerHTML={{
                          __html: isActivite ? forceLinksInNewTab(description) : description,
                        }}
                      />
                    </Typography>
                  )}
                </div>
                <div className={classes.newMainContainer}>
                  {/* <Typography className={classes.registeredAttendeeLabels}>
                    Your registration was successful!
                  </Typography> */}

                  {!isUmbrella ? (
                    <div className={classes.smallContainer}>
                      <DownloadActivity
                        button
                        id={wId}
                        name={name}
                        className={classes.addToCalendarBtn}
                      />
                    </div>
                  ) : (
                    <div className={classes.smallContainer}>
                      <Typography className={classes.reminder} component="div">
                        Reminder: Choosing an activity is mandatory and you can
                        modify your choice until
                        <span className={classes.reminderDate}>July 30th.</span>
                      </Typography>
                    </div>
                  )}

                  {!isMandatory && (
                    <>
                      <div className={classes.smallContainer}>
                        <Typography className={classes.registeredAttendeeLabels}>
                          No longer interested in participating in this activity?
                        </Typography>
                      </div>

                      <div className={classes.smallContainer}>
                        <Button
                          onClick={() => setModalType('unregister')}
                          className={classes.unregisterBtn}
                        >
                          Unregister
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {(!attendeeIsRegistered && (isOptional || isActivite || isUmbrella) && !workshopEnded) && (
              <>
                <div className={classes.workshopDetails}>
                  <Typography className={clsx(classes.name, classes.detailsName)}>
                    {name}
                  </Typography>
                  <Typography className={classes.detailsStartTime}>
                    {toAPStyleTime(baseMoment.utc(startDate).tz(eventTimezone).format(timeFormat))}
                  </Typography>

                  {!!description && (
                    <Typography component="div" className={classes.detailsDescription}>
                      <div
                        role="presentation"
                        onClick={handleWorkshopLinkClick(dispatchSetActiveWorkshop)}
                        className={clsx('trix-content', classes.description)}
                        // dangerouslySetInnerHTML={{ __html: textHtml }}
                        dangerouslySetInnerHTML={{
                          __html: isActivite ? forceLinksInNewTab(description) : description,
                        }}
                      />
                    </Typography>
                  )}
                  {/* <div className={classes.descriptionContainer}>
                    <img className={classes.imageContainer} src={imgHtml?.src} alt="" />
                  </div> */}
                </div>
                {((isOptional || isActivite) && !isUmbrella) && (
                  <div className={classes.newMainContainer}>
                    <div className={classes.secondRow}>
                      {!!availability && (
                        <Typography className={classes.remainingSeatsText}>
                          remaining spaces: {availability - usedSeats}/{availability}
                        </Typography>
                      )}
                      {/* <BorderLinearProgress variant="determinate" value={progress} /> */}
                      <Typography className={classes.optionalWorkshopHelperText}>
                        This is an optional session.
                        Please click below to register if you wish to attend.
                      </Typography>
                    </div>
                    <div className={classes.thirdRow}>
                      {/* {isActivite && (
                        <Typography className={classes.optionalWorkshopHelperText}>
                          Reminder: Choosing an activity is mandatory.<br />
                          You can modify your choice until July 30th.<br />
                          Please click below to register.
                        </Typography>
                      )} */}
                      <Button
                        variant="primary"
                        className={classes.button}
                        onClick={register}
                        disabled={
                          !!availability && (usedSeats >= availability)
                        }
                      >
                        {t('stage:actions.register')}
                      </Button>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* no lo quito del todo porque me huele a que va a tocar volver a poner esto */}
            {/* {false && eventMap && attendanceModeHelper.getMap(workshopAttendanceMode) && (
              <>
                <Typography className={classes.subtitle} variant="subtitle2">
                  {t('title.location')}
                </Typography>
                <img className={classes.image} src={eventMap} alt={t('info.location')} />
              </>
            )} */}
            {!!workshopFiles.length && (
              <>
                <Typography className={classes.subtitle} variant="subtitle2">
                  {t('title.attachments')}
                </Typography>
                <div className={classes.filesContainer}>
                  {workshopFiles.map((file) => (
                    <AttachmentFile key={file.id} file={file} />
                  ))}
                </div>
              </>
            )}
            {/* {live && showJoinButton && (
              <Typography className={classes.invitation}>
                <Trans t={t} i18nKey="stage:activity.invitation">
                  We’re live on {{ streamingType }}, click on <i>join</i> to get started
                </Trans>
              </Typography>
            )} */}
            {showJoinButton && !workshopEnded && (
              <div className={classes.newMainContainer}>
                <Button
                  variant="primary"
                  className={clsx(classes.button, classes.centeredButton)}
                  onClick={joinStream}
                  // icon={<VideocamIcon />}
                >
                  {t('stage:actions.join')}
                </Button>
              </div>
            )}
            {replayAvailable && workshopEnded && (
              <div className={classes.newMainContainer}>
                <Button
                  variant="primary"
                  className={clsx(classes.button, classes.centeredButton)}
                  onClick={goToReplay}
                  disabled={
                    !!availability && (usedSeats >= availability)
                  }
                >
                  Access Replay
                </Button>
              </div>
            )}
            <Message
              onClose={() => setMessage(({ type }) => ({
                type,
              }))}
              type={message?.type}
              title={message?.title}
              message={message?.message}
              className={classes.message}
            />
            {showFreeRegisterButton && showAdvice && (
              <Message
                className={classes.advice}
                onClose={() => setShowAdvice(false)}
                message={t('stage:activity.freeWorkshopAdvice')}
                type="warning"
              />
            )}
            {showRegisterToPaidWorkshopButton && showAdvice && (
              <Message
                className={classes.advice}
                onClose={() => setShowAdvice(false)}
                message={t('stage:activity.paymentAdvice', { button: purchaseButton.label })}
                type="warning"
              />
            )}
            {!!modalType && (
              <Modal
                open
                handleClose={closeModal}
                classes={{ paper: classes.modalPaper }}
              >
                <div className={classes.dialog}>
                  <div className={classes.modalContent}>
                    <Typography className={classes.modalText}>
                      {modalConfig[modalType].text}
                    </Typography>
                    {modalConfig[modalType].helperText}
                  </div>
                  <div className={classes.modalButtons}>
                    <Button
                      small
                      onClick={closeModal}
                      className={clsx(classes.modalButton, classes.modalBtnCancel)}
                    >
                      {t('global:actions.cancel')}
                    </Button>
                    <Button
                      small
                      onClick={modalConfig[modalType].onAccept}
                      className={classes.modalButton}
                    >
                      {modalConfig[modalType].buttonText}
                    </Button>
                  </div>
                </div>
              </Modal>
            )}
            {highlightRegistered && attendeeIsRegisteredAndPaid
              && allowRegistration && showOnRegister && freeWorkshop && (
                <>
                  <Typography className={classes.invitation}>
                    {t('stage:activity.notInterested')}
                  </Typography>
                  <div className={classes.buttons}>
                    <Button
                      variant="secondary"
                      className={classes.button}
                      onClick={() => setModalType('unregister')}
                      icon={<RemoveCircleOutlineIcon />}
                    >
                      {t('stage:actions.unregister')}
                    </Button>
                  </div>
                </>
            )}
          </>
        )}
    </div>
  );
};

Workshop.propTypes = {
  attendeeUnregisterError: PropTypes.string,
  attendeeRegisterSuccess: PropTypes.bool,
  attendeeRegisterError: PropTypes.string,
  attendeeWorkshops: PropTypes.objectOf(
    CustomPropTypes.attendeeWorkshops
  ),
  workshopDefinitions: PropTypes.objectOf(
    CustomPropTypes.workshopDefinition
  ),
  appSettings: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  events: PropTypes.objectOf(
    CustomPropTypes.event
  ).isRequired,
  speakerId: PropTypes.string,
  workshop: CustomPropTypes.workshop.isRequired,
  speakers: PropTypes.objectOf(
    CustomPropTypes.speaker
  ),
  entities: CustomPropTypes.entities.isRequired,
  callApi: PropTypes.func.isRequired,
  setActiveWorkshop: PropTypes.func.isRequired,
  eventFiles: PropTypes.objectOf(
    CustomPropTypes.eventFile
  ),
  currentAttendanceMode: PropTypes.oneOf([PHYSICAL, VIRTUAL]),

};

Workshop.defaultProps = {
  speakerId: undefined,
  speakers: {},
  eventFiles: {},
  attendeeWorkshops: {},
  workshopDefinitions: {},
  attendeeRegisterSuccess: false,
  attendeeUnregisterError: undefined,
  attendeeRegisterError: undefined,
  currentAttendanceMode: '',
};

const mapStateToProps = ({
  fetchStatus: {
    registerAttendee: {
      success: attendeeRegisterSuccess,
      error: attendeeRegisterError,
    },
    unregisterAttendee: {
      error: attendeeUnregisterError,
    },
    registrationToken: {
      isFetching: fetchingRegistrationToken,
    },
  },
  app: {
    activeSubpage: {
      speakerId,
    },
    attendanceType: currentAttendanceMode,
  },
  entities,
  entities: {
    attendeeWorkshops,
    appSettings,
    speakers,
    eventFiles,
    events,
    workshopDefinitions,
  },
}) => ({
  entities,
  currentAttendanceMode,
  attendeeWorkshops,
  appSettings,
  events,
  speakerId,
  speakers,
  eventFiles,
  attendeeUnregisterError,
  attendeeRegisterSuccess,
  attendeeRegisterError,
  fetchingRegistrationToken,
  workshopDefinitions,
});

export default connect(
  mapStateToProps,
  { callApi, setActiveWorkshop }
)(Workshop);
